import styled from 'styled-components'

export const StyledMyPageMyNews = styled.div`
  padding: 0 15px;
`
